<!-- components/typography/ThentiH1.vue -->
<template>
  <h1 class="text-center text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-12">
    <span class="bg-gradient-to-r from-thenti-100 to-thenti-900 bg-clip-text text-transparent">
      <slot />
    </span>
  </h1>
</template>
